import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "phone-frame"
};
const _hoisted_2 = {
  class: "mp-navbar"
};
const _hoisted_3 = {
  class: "mp-navbar-title"
};
const _hoisted_4 = {
  key: 0,
  class: "mp-loading"
};
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
const MP_LOGICAL_WIDTH = 375;
export default {
  __name: 'MpPhoneFrame',
  props: {
    // 导航栏标题（与小程序页面标题一致）
    title: {
      type: String,
      required: true
    },
    // 是否显示「加载中...」占位
    loading: {
      type: Boolean,
      default: false
    },
    // 内容区底色（资讯详情为白色；FAQ/政策详情为 #f6f6f8）
    contentBg: {
      type: String,
      default: '#ffffff'
    }
  },
  setup(__props) {
    // 小程序 rpx 以 750rpx = 屏宽为基准，即 375px 逻辑宽度；
    // 预览样式按 rpx÷2 的固定 px 编写，必须渲染在 375px 宽、再整体 zoom 到实际框宽
    const screenRef = ref(null);
    const screenSize = ref({
      width: 0,
      height: 0
    });
    let resizeObserver = null;
    onMounted(() => {
      resizeObserver = new ResizeObserver(([entry]) => {
        screenSize.value = {
          width: entry.contentRect.width,
          height: entry.contentRect.height
        };
      });
      resizeObserver.observe(screenRef.value);
    });
    onBeforeUnmount(() => {
      resizeObserver?.disconnect();
    });
    const zoomStyle = computed(() => {
      const {
        width,
        height
      } = screenSize.value;
      if (!width || !height) {
        return {
          width: `${MP_LOGICAL_WIDTH}px`,
          height: '100%'
        };
      }
      const factor = width / MP_LOGICAL_WIDTH;
      return {
        width: `${MP_LOGICAL_WIDTH}px`,
        height: `${height / factor}px`,
        zoom: factor
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "screenRef",
        ref: screenRef,
        class: "phone-screen"
      }, [_createElementVNode("div", {
        class: "mp-zoom",
        style: _normalizeStyle(zoomStyle.value)
      }, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"mp-statusbar\" data-v-957815dc><span data-v-957815dc>9:41</span><span class=\"mp-statusbar-icons\" data-v-957815dc><i class=\"mp-signal\" data-v-957815dc></i><i class=\"mp-wifi\" data-v-957815dc></i><i class=\"mp-battery\" data-v-957815dc></i></span></div>", 1)), _createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("svg", {
        class: "mp-back",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "m15 18-6-6 6-6"
      })], -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "mp-share-icon"
      }, null, -1))]), __props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, "加载中...")) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "mp-content",
        style: _normalizeStyle({
          background: __props.contentBg
        })
      }, [_renderSlot(_ctx.$slots, "default"), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "mp-bottom-placeholder"
      }, null, -1))], 4)), _renderSlot(_ctx.$slots, "cta")], 4)], 512)]);
    };
  }
};